import styled from 'styled-components';
import { Flex } from '../../layout/Flex';

export const Wrapper = styled(Flex).withConfig({ displayName: 'AdvertisingShopCard' }).attrs({
    p: 1,
    borderRadius: 3,
    background: 'var(--control-tertiary-background)',
})``;
